import React from "react";
import {Button, Nav, Navbar, NavbarBrand, NavItem} from "reactstrap";
import {withRouter} from "react-router-dom";
import securityService from "../services/securityService";
import {HiOutlineHome} from "react-icons/hi";
import {RiHomeOfficeFill} from "react-icons/ri";
import {getNewUiUrl} from "../utils/urlHelper";


class AppNavBar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    logout = (event) => {
        event.preventDefault();
        localStorage.clear();
        sessionStorage.clear();
        const baseUrl = getNewUiUrl();
        if (baseUrl) {
            window.location.href = baseUrl + "/?logout=true&sync_logout=true";
        } else {
            window.location.href = "/?logout=true";
        }
    }

    showCRMorLogout = () => {

        if (securityService.hasAnyRole(["ROLE_SUPER_ADMIN", "ROLE_TENANT_ADMIN", "ROLE_ADMIN", "ROLE_LEVEL1",
            "ROLE_LEVEL2", "ROLE_LEVEL3"])) {
            return (<span
                color="default"
                className="mb-3 xgnav-link"
                style={{cursor: "pointer"}}
                onClick={(event) => {
                    event.preventDefault();
                    this.props.history.push("/crm/dashboard"); // Navigate to CRM if logged in
                }}
            >
                        Switch to CRM
                      </span>)
        } else if (securityService.hasAnyRole(["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"])) {
            return (<span
                color="default"
                className="mb-3 xgnav-link"
                style={{cursor: "pointer"}}
                onClick={(event) => {
                    event.preventDefault();
                    this.props.history.push("/user/dashboard"); // Navigate to CRM if logged in
                }}
            >
                        Switch to Dashboard
                      </span>)
        } else if (securityService.hasAnyRole(["ROLE_FREE"])) {
            return (<span
                color="default"
                className="mb-3 xgnav-link"
                style={{cursor: "pointer"}}
                onClick={(event) => {
                    event.preventDefault();
                    this.props.history.push("/user/drive/shared"); // Navigate to CRM if logged in
                }}
            >
                        My Drive
                      </span>)
        } else if (securityService.hasAnyRole(["ROLE_STARTER"])) {
            return (<span
                color="default"
                className="mb-3 xgnav-link"
                style={{cursor: "pointer"}}
                onClick={(event) => {
                    event.preventDefault();
                    this.logout(event);
                }}
            >
                        Logout
                      </span>)
        }
    }

    render() {
        return (
            <Navbar color="white" light expand="md">
                <NavbarBrand 
                    href="/" 
                    style={{
                        fontFamily: "'Outfit', sans-serif",
                        fontSize: "1.5rem",
                        fontWeight: 600,
                        letterSpacing: "-0.01em",
                        color: "#1e293b"
                    }}
                >
                    Xare<span style={{ color: "#1e40af" }}>Growth</span>
                </NavbarBrand>
                <Nav className="ml-auto" navbar={true} style={{zIndex: "10000"}}>
                    <NavItem>
                        <span color="default" className="mb-3 xgnav-link"
                               onClick={(event) => {
                                   event.preventDefault();
                                   window.location.href = getNewUiUrl() + "/";
                               }}
                        >
                            <HiOutlineHome style={{marginTop:"-6px"}}/>
                        </span>&nbsp;&nbsp;&nbsp;
                            <span color="default" className="mb-3 xgnav-link"
                                  onClick={(event) => {
                                      event.preventDefault();
                                      window.location.href = getNewUiUrl() + "/about-us";
                                  }}
                            >About Us</span>&nbsp;&nbsp;&nbsp;
                        {/*<span color="default" className="mb-3 xgnav-link"
                              onClick={(event) => {
                                  event.preventDefault();
                                  this.props.history.push("/");
                              }}
                        >Services</span>&nbsp;&nbsp;&nbsp;
                        <span color="default" className="mb-3 xgnav-link"
                              onClick={(event) => {
                                  event.preventDefault();
                                  this.props.history.push("/knowledgeCentre");
                              }}
                        >
                  Knowledge
                </span>&nbsp;&nbsp;&nbsp;
                        <span color="default" className="mb-3 xgnav-link"
                              onClick={(event) => {
                                  event.preventDefault();
                                  this.props.history.push("/xareview");
                              }}
                        >
                  Trust Score
                </span>&nbsp;&nbsp;&nbsp;*/}
                        <span color="default" className="mb-3 xgnav-link"
                               onClick={(event) => {
                                   event.preventDefault();
                                   window.location.href = getNewUiUrl() + "/solutions";
                               }}
                         >
                   Solutions
                 </span>&nbsp;&nbsp;&nbsp;
                         <span color="default" className="mb-3 xgnav-link"
                                onClick={(event) => {
                                    event.preventDefault();
                                    window.location.href = getNewUiUrl() + "/pricing";
                                }}
                          >
                    Prices
                              </span>&nbsp;&nbsp;&nbsp;
                        <>
                            {localStorage.getItem("userId") ? this.showCRMorLogout() : (<Button
                                style={{ marginTop: "12px" }}
                                outline
                                color="default"
                                className="mb-3 xgnav-link"
                                onClick={(event) => {
                                    event.preventDefault();
                                    this.props.loginModalToggle("loginModal")
                                }}
                            >
                        Login
                      </Button>)}
                        </>
                    </NavItem>
                </Nav>
            </Navbar>
        )
    }
}

export default withRouter(AppNavBar);